<ng-container [formGroup]="parent">
  <div [formGroupName]="formgroupName" class="hidecollapseinchild">
    <div class="form-group has-float-label mb-2">
      <div class="form-group has-float-label">
        <label class="form-label"
          >Delivery Address <span class="madatory-field">*</span></label
        >
        <p-select
          [formControlName]="addressField['deliveryAddressfield']"
          (onChange)="onDeliveryAddressChange($event, shipAddressPopover)"
          [ngClass]="{
            'has-error': formErrors[addressField['deliveryAddressfield']],
          }"
          (blur)="logValidationErrors()"
          [options]="deliveryAddress"
          [filter]="true"
          [showClear]="true"
          optionLabel="name"
          optionValue="value"
          optionDisabled="status">
        </p-select>

        <span
          class="error-msg"
          *ngIf="formErrors[addressField['deliveryAddressfield']]">
          {{ formErrors[addressField["deliveryAddressfield"]] }}
        </span>
      </div>
    </div>

    <div class="ship-address">
      <div
        class="form-group has-float-label mb-2"
        *ngIf="shipToAddress"
        id="dropdownBasic2">
        <label class="form-label">Client Ship To Name</label>
        <input
          pInputText
          #shipaddressInput
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="shiftToAddressField"
          (click)="
            onshipToAddressFilter($event, shipAddressPopover, shipaddressInput)
          " />
      </div>
      <p-popover #shipAddressPopover aria-labelledby="dropdownBasic2">
        <!-- <ng-scrollbar style="height: 200px"> -->
        <p-table
          #dt
          [value]="shiftToAddressList"
          styleClass="p-datatable-customers po-small"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Name and Description</th>
              <th class="name">Address</th>
              <th class="vaccount">Street</th>
              <th class="sname">Purpose</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-shiftToAddressLists
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onShitToAddressSeletion(shiftToAddressLists, shipAddressPopover)
              ">
              <td class="name mousepointer">
                {{ shiftToAddressLists.descriptionD365 }}
              </td>
              <td class="name mousepointer">
                {{ shiftToAddressLists.addressD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ shiftToAddressLists.streetD365 }}
              </td>
              <td class="sname mousepointer">
                {{ shiftToAddressLists.rolesD365 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No address found.</td>
            </tr>
          </ng-template>
        </p-table>
        <!-- </ng-scrollbar> -->
      </p-popover>
    </div>

    <div class="v-account">
      <div
        class="form-group has-float-label mb-2"
        *ngIf="vendorAccountAndBook"
        id="dropdownBasic5">
        <label class="form-label">Vendor Account</label>
        <input
          pInputText
          #vendoracountInput
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="vendorAccountSeletion"
          (input)="searchVendor$.next($any($event.target).value)"
          (keypress)="
            onVendorSearchOpenToggle(
              $event,
              vendoracountPopover,
              vendoracountInput
            )
          " />
      </div>

      <p-popover #vendoracountPopover aria-labelledby="dropdownBasic5">
        <!-- <ng-scrollbar style="height: 200px; width: 500px; overflow: scroll;"> -->

        <p-table
          #dt
          [value]="vendorList"
          styleClass="p-datatable-customers po-small"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          scrollHeight="350px"
          [size]="'small'"
          [resizableColumns]="true"
          [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
          [paginator]="true"
          [paginator]="false"
          [filterDelay]="0"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="name">Name or description</th>
              <th class="vaccount">Address</th>
              <th class="sname">Purpose</th>
              <th class="sname">Primary</th>
              <th class="sname">Val</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-vendorList let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onVendorAccountSelection(
                  vendorList,
                  vendoracountPopover,
                  $event
                )
              ">
              <td class="name mousepointer">
                {{ vendorList.vendorName }}
              </td>
              <td class="vaccount mousepointer">
                {{ vendorList.addressD365 }}
              </td>
              <td class="sname mousepointer">
                {{ vendorList.purpose }}
              </td>
              <td class="sname mousepointer">
                {{ vendorList.primary }}
              </td>
              <td class="sname mousepointer">
                <input
                  pInputText
                  [disabled]="true"
                  class="form-check-input me-2"
                  type="checkbox" />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No address found.</td>
            </tr>
          </ng-template>
        </p-table>

        <!-- </ng-scrollbar> -->
      </p-popover>
    </div>

    <div class="selectionvisible">
      <div class="form-group has-float-label mb-2" *ngIf="vendorAccountAndBook">
        <label class="form-label">Vendor Address Book</label>
        <input
          pInputText
          jniAutoCompleteBlocker
          #vendoraddressbook
          type="text"
          class="form-control"
          placeholder=""
          [value]="addressBookName"
          (click)="
            onVendorAddressBookSelect(
              $event,
              vendoraddressbookPopoover,
              vendoraddressbook
            )
          " />
      </div>
      <p-popover #vendoraddressbookPopoover>
        <p-table
          #dt
          [value]="addressBookList"
          styleClass="p-datatable-customers po-small"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="vaccount">Address</th>
              <th class="sname">Purpose</th>
              <th class="sname">Street</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-addressBookLists
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onVendorAddressBookSelection(
                  addressBookLists,
                  vendoraddressbookPopoover
                )
              ">
              <td class="vaccount mousepointer">
                {{ addressBookLists.addressD365 }}
              </td>
              <td class="sname mousepointer">
                {{
                  addressBookLists.purposeD365 === "1" ? "Busniess" : "Others"
                }}
              </td>
              <td class="vaccount mousepointer">
                {{ addressBookLists.streetD365 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No address found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-popover>
    </div>

    <!-- <div class="form-group has-float-label mb-2" [hidden]="!showAddress">
        <textarea
          jniAutoCompleteBlocker
          placeholder=""
          class="form-control"
          formControlName="addressD365"
        ></textarea>
        <label class="form-label">Address</label>
      </div> -->

    <div
      class="form-group has-float-label mb-2 address-lookup"
      [hidden]="showAddress">
      <!-- <input pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        [formControlName]="addressField.addressFormatField"
        [ngModel]="melissa"
        (selectItem)="selectedStreet($event)"
        [resultFormatter]="malisaFormatter"
        [inputFormatter]="malisaFormatter"
        [ngbTypeahead]="searchMelissa" /> -->
      <!-- <p-autoComplete
        jniAutoCompleteBlocker
        class="form-control"
        pInputText
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        formControlName="addressFormat"
        [ngModel]="melissaForNonUsAddress1"
        (completeMethod)="getMelissaGlobalData($event.query)"
        (onSelect)="selectedStreetForNonUs($event)"
        (change)="enableAndDisabledValidateButton()"> -->
      <label class="form-label">Address Lookup</label>
      <p-autocomplete
        jniAutoCompleteBlocker
        id="addressFormat"
        name="addressFormat"
        formControlName="addressFormat"
        [ngModel]="melissa"
        (onSelect)="selectedStreet($event)"
        (completeMethod)="searchMelissaAutoComplete($event)"
        (onChange)="enableAndDisabledValidateButton()"
        [suggestions]="usSuggestions"
        [forceSelection]="false"
        [dropdown]="false">
        <ng-template let-address #item>
          {{ melissaFormatter(address) }}
        </ng-template>
      </p-autocomplete>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ selectionvisible: !collapseStatus }"
      [hidden]="showAddress">
      <label class="form-label"
        >Country/Region <span class="madatory-field">*</span></label
      >
      <p-select
        [(ngModel)]="countryRegionSelectedId"
        [formControlName]="addressField['countryRegionfield']"
        [ngClass]="{
          'has-error': formErrors[addressField['countryRegionfield']],
        }"
        (onBlur)="logValidationErrors()"
        (onChange)="onCountryRegionSelection(countryRegionSelectedId)"
        [options]="countryRegionList"
        optionLabel="countryRegionD365"
        optionValue="countryRegionD365"
        [filter]="true"
        [showClear]="true">
      </p-select>

      <span
        class="error-msg"
        *ngIf="formErrors[addressField['countryRegionfield']]">
        {{ formErrors[addressField["countryRegionfield"]] }}
      </span>
    </div>

    <div
      [ngClass]="{ hidechildelement: appartmentFieldStatus }"
      [hidden]="appartmentFieldStatus">
      <div
        class="form-group has-float-label mb-2"
        *ngIf="appartmentList.length">
        <label class="form-label">Suite Selection Box</label>
        <p-select
          [(ngModel)]="selectedAppartment"
          formControlName="buildingComplimentD365"
          (onChange)="onAppartmentSelection($event)"
          [ngClass]="{ 'has-error': !appartmentFieldStatus }"
          #selector
          [options]="appartmentList">
        </p-select>
      </div>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <!-- <input pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        [formControlName]="addressField.addressFormatField"
        [ngModel]="melissaForNonUsAddress1"
        [resultFormatter]="malisaFormatterNonUs"
        [inputFormatter]="malisaFormatterNonUs"
        [ngbTypeahead]="getMelissaGlobalData"
        (selectItem)="selectedStreetForNonUs($event)"
        (change)="enableAndDisabledValidateButton()" /> -->
      <label class="form-label"
        >Address Line 1<span class="madatory-field">*</span></label
      >
      <p-autoComplete
        jniAutoCompleteBlocker
        class="form-control"
        pInputText
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        formControlName="addressFormat"
        [ngModel]="melissaForNonUsAddress1"
        (completeMethod)="getMelissaGlobalData($event.query)"
        (onSelect)="selectedStreetForNonUs($event)"
        (change)="enableAndDisabledValidateButton()">
        <ng-template let-item pTemplate="item">
          {{ item.Address?.Address }}
        </ng-template>
      </p-autoComplete>
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label">Address Line 2</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        [formControlName]="addressField['addressLine2Field']"
        [(ngModel)]="address2" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label">Address Line 3</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        [formControlName]="addressField['addressLine3Field']"
        [(ngModel)]="address3" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >City/Locality <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="cityD365"
        name="cityD365"
        placeholder=""
        [formControlName]="addressField['cityD365Field']"
        [(ngModel)]="city"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >State/Province <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="stateD365"
        name="stateD365"
        placeholder=""
        [formControlName]="addressField['stateD365Field']"
        [(ngModel)]="state"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >Postal Code <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="zipCodeD365"
        name="zipCodeD365"
        placeholder=""
        [formControlName]="addressField['zipCodeD365Field']"
        [(ngModel)]="postalcode"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >Street <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="streetD365"
        name="streetD365"
        placeholder=""
        [formControlName]="addressField['streetD365Field']" />
    </div>

    <div class="form-group has-float-label mb-2" *ngIf="showName">
      <label class="form-label">Name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        formControlName="deliveryNameD365"
        [ngClass]="{ 'has-error': formErrors['deliveryNameD365'] }"
        (blur)="logValidationErrors()" />

      <span class="error-msg" *ngIf="formErrors['deliveryNameD365']">
        {{ formErrors["deliveryNameD365"] }}
      </span>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{
        selectionvisible: !collapseStatus,
        selectionforcedvisible: attentionFieldStatus,
      }">
      <label class="form-label">Attention</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        placeholder=""
        [formControlName]="addressField['attentionInformationD365Field']"
        maxlength="30" />
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ selectionvisible: !collapseStatus }">
      <label class="form-label">location</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        placeholder=""
        [formControlName]="addressField['locationD365Field']"
        maxlength="30" />
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ selectionvisible: !collapseStatus }">
      <label class="form-label" for="c_name">Address</label>
      <textarea
        pInputText
        jniAutoCompleteBlocker
        [formControlName]="addressField['addressD365Field']"
        class="form-control"
        style="height: 100px"
        (change)="formattedAddressChange()"
        [ngClass]="{ 'has-error': isAddressError }"></textarea>

      <span class="error-msg" *ngIf="isAddressError">
        Address is not valid
      </span>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: isPrimaryFieldStatus }"
      [hidden]="isPrimaryFieldStatus">
      <div class="switcher">
        <div class="form-label mb-1">Primary:</div>
        <div class="d-flex align-items-center form-switch">
          <label class="form-check-label" for="rcCheck">{{
            this.parent.get(["addressInformation", "isPrimaryD365"])?.value
          }}</label>
          <input
            pInputText
            name="rcCheck"
            class="form-check-input me-2"
            [checked]="false"
            type="checkbox"
            id="rcCheck"
            [formControlName]="addressField['isPrimaryD365Field']" />
        </div>
      </div>
    </div>

    <div class="form-group has-float-label mb-2" [hidden]="true">
      <label class="form-label" for="c_name">validateAddress</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        [formControlName]="addressField['validateAddressField']"
        class="form-control"
        style="height: 120px" />
    </div>

    <div class="col mb-2 d-flex align-items-center justify-content-end">
      <div class="form-group has-float-label">
        <button
          type="button"
          style="margin-left: 10px"
          (click)="validateAddress(true)"
          [hidden]="hideValidateButton"
          class="btn validate"
          [ngClass]="{
            'btn-success': addressValidationStatus === false,
            'btn-primary': addressValidationStatus === true,
            'btn-danger': isAddressError === true,
          }">
          Validate address
        </button>
      </div>
    </div>

    <div
      class="form-group has-float-label mt-2"
      [ngClass]="{ selectionvisible: !collapseStatus }">
      <label class="form-label">Ship to email</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="email"
        class="form-control"
        placeholder=""
        [formControlName]="addressField['shipToEmail']"
        [ngClass]="{ 'has-error': formErrors['shipToEmail'] }"
        (blur)="logValidationErrors()" />

      <span class="error-msg" *ngIf="formErrors['shipToEmail']">
        {{ formErrors["shipToEmail"] }}
      </span>
    </div>
  </div>
</ng-container>
